var map = {
	"./bg-BG.json": 1546,
	"./ca-ES.json": 1547,
	"./cs-CZ.json": 1548,
	"./de-DE.json": 1549,
	"./en-US.json": 881,
	"./es-ES.json": 1550,
	"./et-EE.json": 1551,
	"./fi-FI.json": 1552,
	"./fr-FR.json": 1553,
	"./he-IL.json": 1554,
	"./it-IT.json": 1555,
	"./ja-JP.json": 1556,
	"./ko-KR.json": 1557,
	"./nb-NO.json": 1558,
	"./pl-PL.json": 1559,
	"./pt-BR.json": 1560,
	"./ru-RU.json": 1561,
	"./sv-SE.json": 1562,
	"./tr-TR.json": 1563,
	"./zh-CN.json": 1564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1545;